<div class="grid-container p-12:b md:p-16:b lg:p-24:b">
    <div class="g-12 lg:g-3">
        <strong>{{ label }}:</strong>
    </div>
    <div class="g-12 lg:g-9">
        <ng-content></ng-content>
    </div>
</div>
